import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/printful.constant";

export {
    addPrintfulSyncs,
    addSinglePrintfulSyncs,
    updateSinglePrintfulSyncs,
    getSinglePrintfulSyncs,
    getAllPrintfulSyncs,
    searchPrintfulSyncs,
    searchPrintfulSyncsWithSearchCriteria,
    preparePrintfulSyncsList
}

const collectionName = 'printful-syncs';
const collectionReference = collection(fireStoreDB, collectionName);

const addPrintfulSyncs = (printfulSyncs) => {
    return Promise.map(printfulSyncs, async printfulSyncs => {
        await addSinglePrintfulSyncs(printfulSyncs);
    });
}

const addSinglePrintfulSyncs = (printfulSyncs) => {
    printfulSyncs.createdAt = new Date();
    printfulSyncs.updatedAt = printfulSyncs.createdAt;
    return addDoc(collectionReference, printfulSyncs);
}

const updateSinglePrintfulSyncs = (printfulSyncs) => {
    const documentReference = doc(fireStoreDB, collectionName, printfulSyncs.id);
    printfulSyncs.updatedAt = new Date();
    return setDoc(documentReference, printfulSyncs);
}

const getSinglePrintfulSyncs = async (printfulSyncsId) => {
    const documentReference = doc(fireStoreDB, collectionName, printfulSyncsId);
    const printfulSyncsDoc = await getDoc(documentReference);
    return prepareSinglePrintfulSyncs(printfulSyncsDoc);
}

const getAllPrintfulSyncs = async () => {
    let searchQuery = query(collectionReference);
    const printfulSyncsResult = await getDocs(searchQuery);
    return preparePrintfulSyncsList(printfulSyncsResult);
}

const searchPrintfulSyncs = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const printfulSyncsResult = await getDocs(searchQuery);
    return preparePrintfulSyncsList(printfulSyncsResult);
}

const searchPrintfulSyncsWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchPrintfulSyncsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const printfulSyncsResult = await getDocs(searchQuery);
    return preparePrintfulSyncsList(printfulSyncsResult);
}

const preparePrintfulSyncsList = (printfulSyncsResult) => {
    const printfulSyncsList = [];

    _.forEach(printfulSyncsResult.docs, printfulSyncsDoc => {
        printfulSyncsList.push(prepareSinglePrintfulSyncs(printfulSyncsDoc));
    });

    return printfulSyncsList;
}


const prepareSinglePrintfulSyncs = (printfulSyncsDoc) => {
    const printfulSyncs = printfulSyncsDoc.data();
    printfulSyncs.id = printfulSyncsDoc.id;
    return printfulSyncs;
}
